// src/features/analytics/components/AnalyticsErrorState.tsx

import { Alert, Button, Stack, Text } from '@mantine/core';
import { IconAlertTriangle, IconInfoCircle } from '@tabler/icons-react';
import { DateTime } from 'luxon';
import { AnalyticsUtils } from '../AnalyticsUtils';

interface AnalyticsErrorStateProps {
  error: unknown;
  onRetry?: () => void;
}

const RETRYABLE = new Set(['busy', 'timeout', 'generic']);

/** Render a query error via the feature error mapping (code first, status second). */
export function AnalyticsErrorState({ error, onRetry }: AnalyticsErrorStateProps) {
  const view = AnalyticsUtils.errorView(error);
  const informational = view.kind === 'empty' || view.kind === 'notEnabled';

  return (
    <Alert
      color={informational ? 'gray' : 'yellow'}
      icon={informational ? <IconInfoCircle size={16} /> : <IconAlertTriangle size={16} />}
      title={view.title}
    >
      <Stack gap="xs">
        {view.detail && <Text size="sm">{view.detail}</Text>}
        {view.availableFrom !== undefined && (
          <Text size="sm">
            Data is available from{' '}
            {DateTime.fromSeconds(view.availableFrom, { zone: 'utc' }).toFormat('MMM d, yyyy')}{' '}
            (UTC).
          </Text>
        )}
        {onRetry && RETRYABLE.has(view.kind) && (
          <Button variant="light" size="xs" w="fit-content" onClick={onRetry}>
            Retry
          </Button>
        )}
      </Stack>
    </Alert>
  );
}
